import { combineReducers } from 'redux';

import appReducer from 'apps/web_forms/slices/appSlice';
import formReducer from 'apps/web_forms/slices/formSlice';
import multimediaReducer from 'apps/web_forms/slices/multimediaSlice';
import resourceReducer from 'apps/web_forms/slices/resourceSlice';

export default combineReducers({
  app: appReducer,
  form: formReducer,
  multimedia: multimediaReducer,
  resource: resourceReducer,
});
